export default __webpack_public_path__ + "static/media/add_service_offer.67489b91.svg";